import React, { useEffect } from "react";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Routes from "./Routes";
import { AuthProvider } from './contexts/AuthContext';
import { DashboardDataProvider } from './contexts/DashboardDataContext';
import { SidebarProvider } from './contexts/SidebarContext';
import ChatBot from './components/ui/ChatBot';

// Configure React Query for optimal caching
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 2, // Data stays fresh for 2 minutes
      gcTime: 1000 * 60 * 10,   // Cache kept for 10 minutes
      refetchOnWindowFocus: false, // Don't refetch when switching tabs
      retry: 2, // Retry failed requests twice
    },
  },
});

function App() {
  // Apply dark theme by default
  useEffect(() => {
    document.documentElement.classList.add('dark');
    document.documentElement.style.colorScheme = 'dark';
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <DashboardDataProvider>
          <SidebarProvider>
            <Routes />
            {/* M.U.S.E. AI Chat - Available on all dashboards */}
            <ChatBot position="bottom-right" />
          </SidebarProvider>
        </DashboardDataProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;